var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCopy = function SvgCopy(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currectColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.4,
    d: "M14.65 7.003c-.607.008-.972.043-1.267.193a1.8 1.8 0 0 0-.787.787c-.15.295-.185.66-.194 1.267M22.75 7.003c.608.008.972.043 1.267.193a1.8 1.8 0 0 1 .787.787c.15.295.185.66.194 1.267m0 8.1c-.009.607-.044.972-.194 1.267a1.8 1.8 0 0 1-.787.787c-.295.15-.66.185-1.267.194M25 12.4v1.8M17.8 7h1.8M9.88 25h6.84c1.008 0 1.512 0 1.897-.196a1.8 1.8 0 0 0 .787-.787c.196-.385.196-.889.196-1.897v-6.84c0-1.008 0-1.512-.196-1.897a1.8 1.8 0 0 0-.787-.787c-.385-.196-.889-.196-1.897-.196H9.88c-1.008 0-1.512 0-1.897.196a1.8 1.8 0 0 0-.787.787C7 13.768 7 14.272 7 15.28v6.84c0 1.008 0 1.512.196 1.897a1.8 1.8 0 0 0 .787.787C8.368 25 8.872 25 9.88 25"
  })));
};
export default SvgCopy;